<template>
  <div class="main-div" :style="{ 'background-color': backgroundColor }">
    <div class="d-none d-lg-block">
      <h1 class="header-text-big" :style="{ color: textColor }">{{ text }}</h1>
    </div>
    <div class="d-md-block d-lg-none">
      <h1 class="header-text-small" :style="{ color: textColor }">{{ text }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    text: String,
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    textColor: {
      type: String,
      default: "#333"
    }
  }
};
</script>

<style scoped>
.main-div {
  width: 100%;
  text-align: center;
  padding: 50px;
}

.header-text-big {
  font-size: 65px;
  font-weight: normal;
  word-break: break-word; 
}

.header-text-small {
  font-size: 7vmax;
  font-weight: normal;
  word-break: break-word; 
}
</style>
